var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SkipAction',{scopedSlots:_vm._u([{key:"default",fn:function({ skip }){return [_c('Action',{attrs:{"icon":"sr-2 sr-v2-eye-slashed","text":"Skip"},on:{"click":function($event){return skip()}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }